import InputMask from 'react-input-mask';
import { Input } from 'antd';

function DateInput(props) {
  return (
    <InputMask
      mask="99/99/9999"
      placeholder="DD/MM/YYYY"
      onChange={props.onChange}
      value={props.value}
      className="input"
      //maskPlaceholder="_"
      //placeholderChar=" "

    >
      {(inputProps) => <Input {...inputProps} style={props.isError ? {border:'1px solid #ff4d4f'} : {border : '1px solid #ccc'}} />}
    </InputMask>
  );
}

export default DateInput;